module.exports = __webpack_public_path__ + "static/construction-01ad6b870ddfac046ca3aebe4019b0b6.svg";